<template>
  <div class="d-flex flex-column">
    <div class="sub-title">Bruto platen</div>

    <table class="panel-rows brutoplate-rows">
      <thead>
        <tr>
          <th class="index">&nbsp;</th>
          <th class="length">Lengte</th>
          <th class="width">Breedte</th>
          <th class="amount">Aantal</th>
          <th class="reference">Plaatreferentie</th>
          <th class="actions">&nbsp;</th>
        </tr>
      </thead>

      <tbody class="panel-rows-body">
        <tr class="spacer-row"><td colspan="8"></td></tr>
        <app-brutoplate-row
          v-for="panel in panels"
          :panel="panel"
          ref="panel"
          :key="panel.id"
        />

        <tr class="disabled-panel-row" @click="addRow">
          <td class="index">
            {{ panels.length + 1 }}
          </td>
          <td class="length">
            <input type="number" disabled class="form-control disabled" min="0" placeholder="mm">
          </td>
          <td class="width">
            <input type="number" disabled class="form-control disabled" min="0" placeholder="mm">
          </td>
          <td class="amount">
            <input type="number" disabled class="form-control disabled" min="0" placeholder="st">
          </td>
          <td class="reference">
            <input type="text" disabled class="form-control disabled" placeholder="">
          </td>

          <td class="actions">
            &nbsp;
          </td>
        </tr>
        <tr class="spacer-row"><td colspan="8"></td></tr>
      </tbody>
    </table>

  </div>
</template>

<script>
  import BrutoPlateRow from '@/components/Tool/Panels/BrutoPlateRow.vue'

  export default {
    data() {
      return {}
    },
    components: {
      'app-brutoplate-row': BrutoPlateRow
    },
    computed: {
      material() {
        return this.$store.getters.material
      },
      panels() {
        if (this.$store.getters.panels && this.material) {
          this.$store.getters.panels.map(panel => {
            panel.length = this.material.total_length
            panel.width = this.material.total_width
            return panel
          })
        }
        return !this.$store.getters.panels ? [] : this.$store.getters.panels
      },
      side1() {
        return this.$store.getters.materialSide1
      },
      side2() {
        return this.$store.getters.materialSide2
      }
    },
    methods: {
      addRow() {
        let id = this.panels.length + 1

        this.panels.push({ id: id, length: null, width: null, amount: null, l1: false, l2: false, b1: false, b2: false, reference: null, valid: null })

        this.$nextTick(function() {
          this.$refs.panel[id - 1].$refs.amount.focus()
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
